import DefaultCell from "application/components/DefaultCell";
import formControl from "globals/form-control";
import { useState } from "react";




const getYearlyColumns = () => {
  const [isEnable, setIsEnable] = useState(false);
  const onChangeServingApp = (event, formik) => {
    console.log(event.target.value);
    if (event.target.value == "transfer") {
      setIsEnable(true);
    } else {
      setIsEnable(false);
    }
  };
  return [
    {
      Header: "Holiday Name",
      accessor: "holidayName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required"),
      width: 6,
    },
    {
      Header: "Date",
      accessor: "date",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      controlType: "date",
      futureDate: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required"),
      width: 6,
    },

    {
      Header: "From Time",
      accessor: "fromTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      defaultValue: "00:01",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "To Time",
      accessor: "toTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      defaultValue: "23:59",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Serving App (transfer type)",
      accessor: "servingApp",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 4,
      controlType: "select",
      onChange: onChangeServingApp,
      validation: formControl.string().required("Required"),
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "hangup", description: "Hangup" },
          { id: "transfer", description: "Transfer" },
          { id: "extensionMode", description: "Extension Mode" },
        ],
        url: "",
      },
    },
    {
      Header: "Serving Data (transfer number)",
      accessor: "servingData",
      displayInList: true,
      allowInForm: isEnable,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 4,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
    },
  ];
};

export { getYearlyColumns };
